import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"
export default function NoResults() {
    const { filters, removeAll } = useProductFilters()
    return (
        <div class="no-results">
            <p>We could not find any products {filters.length > 0 ? ' or selected sizes are not available' : ''}.</p>
            {filters.length > 0 && <a href="#" onClick={event => {
                event.preventDefault()
                removeAll()
            }}>Clear filters</a>}
        </div>
    )
}